export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name':
    'Pixartprinting S.p.A. unique actionnaire, sous la direction et la coordination de Cimpress plc',
  'privacy-policy': 'Politique de Confidentialité',
  'cookie-policy': 'Cookie policy',
  'informazioni-legali': 'Mentions légales',
}
